// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__EV-P0","name":"Profile_name__3---z","name-edit":"Profile_name-edit__SjKtg","email":"Profile_email__F0C8R","title":"Profile_title__jUWij"};